import { render, staticRenderFns } from "./CopyBoardIcon.vue?vue&type=template&id=726dcecb&scoped=true"
import script from "./CopyBoardIcon.vue?vue&type=script&lang=js"
export * from "./CopyBoardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726dcecb",
  null
  
)

export default component.exports